import React from 'react'
import styled from 'styled-components'

import { URL_CONST } from 'utils/urlConsts'

import Link from 'components/lib/DesignSystem/Link'

import ProtectedIcon from './ProtectedIcon'

const ProtectedContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 432px);

  /* New nav: the shell (top bar, global banner, page inset) replaces the legacy 64px header. */
  .platform-nav-content & {
    height: auto;
    min-height: calc(
      100vh - var(--top-bar-height, 52px) - var(--banner-height, 0px) -
        (var(--page-inset, 20px) * 2) - 368px
    );
  }
`

const Title = styled.div`
  font-size: var(--t-typography-font-size-base);
  color: var(--color-text);
  font-weight: var(--t-typography-font-weight-semi-bold);
  margin: 10px 0 15px;
`

const Description = styled.div`
  font-size: var(--t-typography-font-size-xs);
  color: var(--sub-text-color);
  margin-bottom: 2px;
`

const DescriptionValue = styled.span`
  font-weight: var(--t-typography-font-weight-bold);
`

const SuccessState = () => (
  <ProtectedContainer>
    <ProtectedIcon />
    <Title>You&apos;re protected!</Title>
    <Description>
      <div style={{ marginBottom: '10px' }}>
        Great work launching all suggested simulations! <br /> Your organization&apos;s defenses are
        now being tested.{' '}
      </div>
      Head over to the <DescriptionValue>Launched</DescriptionValue> tab to track the results.
    </Description>
    <Link href={URL_CONST.psima.launched}>See results</Link>
  </ProtectedContainer>
)

export default SuccessState
